import React from 'react';
import { useDispatch } from 'react-redux';

import { setActiveDrawer } from '../../../actions/lister-actions';
import { getFinanceData } from '../../../utilities/finance-utilities';
import TRANSLATIONS from './translations@default.json';

const FinanceProposition = ({
	NewDayFinanceQuote,
	FullTitle,
	Promotions: { FinancePromotions } = {},
	PricePodViewModel: { NowPrice } = {},
	classes,
}) => {
	const dispatch = useDispatch();

	if (FinancePromotions?.length > 0) {
		const financeData = getFinanceData(
			FinancePromotions[0].ImageName,
			NowPrice
		);

		switch (financeData.type) {
			case 'InterestFree':
				return (
					<button
						type="button"
						aria-label="Interest Free Finance Promotion"
						className={`${classes} relative z-10 p-0 w-1/2 bg-transparent`}
						onClick={() =>
							dispatch(setActiveDrawer('financeInterestFree', financeData))
						}
						data-tag-name="finance-interest-free-button"
						data-tag-finance-type="finance-interest-free-button"
						data-tag-product={FullTitle}
						data-testid="finance-interest-free">
						<div className="bg-white text-title-sm text-xs text-left">
							<div>{TRANSLATIONS.finance.interestFree}</div>
							<span>{`${financeData.duration} ${TRANSLATIONS.finance.monthInstalment} `}</span>
							<span className="block text-cta-action">
								{TRANSLATIONS.finance.learnMore}
							</span>
						</div>
					</button>
				);

			case 'BuyNowPayLater':
				return (
					<button
						type="button"
						aria-label="Buy Now Pay Later Finance Promotion"
						className={`${classes} relative z-10 p-0 w-1/2 bg-transparent`}
						onClick={() =>
							dispatch(setActiveDrawer('financeBuyNowPayLater', financeData))
						}
						data-tag-name="finance-buy-now-pay-later-button"
						data-tag-finance-type="finance-buy-now-pay-later-button"
						data-tag-product={FullTitle}
						data-testid="finance-buy-now-pay-later">
						<div className="bg-white text-title-sm text-xs text-left">
							<div>
								{`${TRANSLATIONS.finance.buyNowPayIn} ${financeData.duration} ${TRANSLATIONS.finance.months}`}
							</div>
							<span className="text-cta-action">
								{`${TRANSLATIONS.finance.learnMore}`}
							</span>
						</div>
					</button>
				);

			default:
				return null;
		}
	}

	// finance messaging
	if (NewDayFinanceQuote?.PriceIsLessThanMinimum === false) {
		return (
			<button
				type="button"
				aria-label="Instalments Finance Promotion"
				className={`${classes} relative z-10 p-0 w-1/2 bg-white text-title-sm text-xs text-left`}
				onClick={() =>
					dispatch(setActiveDrawer('financeInstalments', NewDayFinanceQuote))
				}
				data-tag-name="finance-instalments-button"
				data-tag-finance-type="finance-instalments-button"
				data-tag-product={FullTitle}
				data-testid="finance-instalments">
				{/* <div className="bg-white border border-gray-30 border-solid p-2 rounded text-title-sm text-xs text-left"> */}
				<div className="font-regular inline">
					{TRANSLATIONS.finance.instalmentsPlan}{' '}
				</div>
				<span className="inline-block mr-1">
					{NewDayFinanceQuote.FormattedMonthlyPriceString}{' '}
					{TRANSLATIONS.finance.perMonth}{' '}
				</span>
				<span className="block text-cta-action">
					{TRANSLATIONS.finance.learnMore}
				</span>
				{/* </div> */}
			</button>
		);
	}

	// default finance messaging
	return (
		<button
			type="button"
			aria-label="Flexible Credit Finance Promotion"
			className={`${classes} relative z-10 p-0 w-1/2 bg-transparent`}
			onClick={() => dispatch(setActiveDrawer('financeFlexibleCredit'))}
			data-tag-name="finance-flexible-credit-button"
			data-tag-finance-type="finance-flexible-credit-button"
			data-tag-product={FullTitle}
			data-testid="finance-flexible-credit">
			<div className="bg-white text-title-sm text-xs text-left">
				<div>{TRANSLATIONS.finance.flexibleCredit} </div>
				<span className="text-cta-action">
					{TRANSLATIONS.finance.learnMore}
				</span>
			</div>
		</button>
	);
};

export default FinanceProposition;
